import styled, { css } from 'styled-components';

export const TableBodyStyled = styled.tbody<{ isClickable?: boolean }>`
  ${({ isClickable }) =>
    isClickable &&
    css`
      tr {
        cursor: pointer;
      }
    `}
`;
